import styled from '@emotion/styled';
import { css, Grid } from '@mui/material';
import { colors } from 'theme/colors';
import { ETypeDay } from './helpers';

interface IStyledDayCardHeader {
  type: ETypeDay;
}
interface IStyledDayCard {
  type: ETypeDay;
}

interface IStyledDayCardItem {
  type: ETypeDay;
  unavailable: boolean;
}

const getColorStyle = (type: ETypeDay) => {
  switch (type) {
    case ETypeDay.vacation:
      return {
        headerBackground: colors.primary50,
        border: colors.primary50,
        color: colors.primary900,
        unavailableBackground: colors.primary25,
      };
    case ETypeDay.holiday:
      return {
        headerBackground: colors.error50,
        border: colors.error50,
        color: colors.error900,
        unavailableBackground: colors.error25,
      };
    default:
      return {
        headerBackground: colors.primary50,
        border: colors.primary50,
        color: colors.primary900,
        unavailableBackground: colors.primary25,
      };
  }
};

export const StyledDayCard = styled(Grid) <IStyledDayCard>`
  ${(props: IStyledDayCard) => css`
    display: grid;
    font-size: 12px;
    height: 100%;
    border-radius: 4px;
    border: 1px solid ${getColorStyle(props.type).border};
    background: ${props.type !== ETypeDay.default
      ? getColorStyle(props.type).unavailableBackground
      : colors.white};
    color: ${getColorStyle(props.type).color} !important;
  `}
`;
export const StyledDayCardHeader = styled(Grid) <IStyledDayCardHeader>`
  ${(props: IStyledDayCardHeader) => css`
    height: 48px;
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    padding: 0px 12px;
    align-items: center;
    background: ${getColorStyle(props.type).headerBackground};
    color: ${getColorStyle(props.type).color} !important;
  `}
`;
export const StyledDayCardItem = styled(Grid) <IStyledDayCardItem>`
  ${(props: IStyledDayCardItem) => css`
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    gap: 4px;
    padding: 10px 12px;
    font-size: 12px;
    background: ${props.unavailable
      ? getColorStyle(props.type).unavailableBackground
      : colors.white};
    color: ${getColorStyle(props.type).color};
  `}
`;
